import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false

console.log('process.env.NODE_ENV: ' + process.env.NODE_ENV)
console.log('process.env.BASE_URL: ' + process.env.BASE_URL)

// ポップアップのモーダルウィンドウ
import ModalDialog from '@/components/ModalDialog'
Vue.component('ModalDialog', ModalDialog)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
